<template>
  <div v-if="thirdPartyTagsData">
    <fresh-chat-widget v-if="thirdPartyTagsData.freshchat"></fresh-chat-widget>
    <intercom-widget v-else-if="thirdPartyTagsData.intercom"></intercom-widget>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import FreshChatWidget from '@/components/FreshChatWidget';
import IntercomWidget from '@/components/IntercomWidget';

export default {
  name: 'ContactSupport',

  components: {
    FreshChatWidget,
    IntercomWidget,
  },

  computed: {
    ...mapGetters(['userProfile']),

    thirdPartyTagsData() {
      return this.userProfile ? this.userProfile.third_party_tags_data : null;
    },
  },
};
</script>
